import { render, staticRenderFns } from "./PurchasesTreeTableRow.vue?vue&type=template&id=47997525&scoped=true"
import script from "./PurchasesTreeTableRow.vue?vue&type=script&lang=js"
export * from "./PurchasesTreeTableRow.vue?vue&type=script&lang=js"
import style0 from "./PurchasesTreeTableRow.vue?vue&type=style&index=0&id=47997525&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47997525",
  null
  
)

export default component.exports